import { Box } from '@factorialco/deprecated-design-system'
import { AvailableModules } from 'generated/featureDefinitions'

import i18n from 'modules/core/lib/i18n'

import { UpsellButton } from 'modules/finance/components/FinancialWorkspace/components/UpsellingButton'
import { REQUEST_SOURCE } from 'modules/finance/components/FinancialWorkspace/consts/requestSource'
import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'

interface UpsellExpensesButtonProps {
  requestComponent?: string
  buttonTexts?: {
    requested: string
    unlock: string
  }
  pageSource?: string
}

export const UpsellExpensesButton = ({
  requestComponent,
  buttonTexts = {
    requested: i18n.t('finance.financial_workspace.payroll.landing.buttons.requested'),
    unlock: i18n.t('finance.financial_workspace.launch_banner.expenses.unlock_button'),
  },
  pageSource,
}: UpsellExpensesButtonProps) => {
  return (
    <Box data-testid="expenses-upsell-button">
      <UpsellButton
        moduleRequested={AvailableModules.expenses}
        reason={ValidReasons.MissingAddon}
        requestSource={
          requestComponent ? `${REQUEST_SOURCE} - ${requestComponent}` : REQUEST_SOURCE
        }
        pageSource={pageSource}
        buttonTexts={buttonTexts}
      />
    </Box>
  )
}
